import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Logo(1).svg";

const Footer = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/footer/getFooter`)
      .then((res) => res.json())
      .then((d) => {
        if (d?.data?.length) setData(d.data[0]);
      });
  }, []);

  const splitLocations = (str) =>
    str?.split(",").map((s) => s.trim()).filter(Boolean) || [];

  const locations = splitLocations(data?.location);

  const handleWhatsApp = () => {
    if (data?.phone) window.open(`https://wa.me/${data.phone}`, "_blank");
  };

  const quickLinks = [
    { to: "/", label: "Home" },
    { to: "/aboutUs", label: "About Us" },
    { to: "/accessories", label: "Accessories" },
    { to: "/lectures", label: "Lectures" },
    { to: "/researches-brochure", label: "Research & Brochure" },
  ];

  const supportLinks = [
    { to: "/faq", label: "FAQ" },
    { to: "/terms-condition", label: "Terms & Conditions" },
    { to: "/privary-policy", label: "Privacy Policy" },
  ];

  const socials = [
    { href: data?.facebook, icon: "ri:facebook-fill", label: "Facebook", color: "hover:bg-blue-600 hover:text-white" },
    { href: data?.instagram, icon: "ri:instagram-fill", label: "Instagram", color: "hover:bg-pink-600 hover:text-white" },
    { href: data?.linkedin, icon: "ri:linkedin-fill", label: "LinkedIn", color: "hover:bg-sky-600 hover:text-white" },
  ];

  return (
    <footer className="bg-slate-50 border-t border-gray-200/80 text-gray-600">

      {/* ── Top contact bar ── */}
      <div className="border-b border-gray-200/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-wrap items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-6">
            {data?.phone && (
              <a
                href={`tel:+${data.phone}`}
                className="flex items-center gap-2.5 text-sm text-gray-700 hover:text-indigo-600 transition-colors group font-medium"
              >
                <span className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
                  <Icon icon="solar:phone-bold" className="w-4 h-4" />
                </span>
                +{data.phone}
              </a>
            )}
            {data?.email && (
              <a
                href={`mailto:${data.email}`}
                className="flex items-center gap-2.5 text-sm text-gray-700 hover:text-indigo-600 transition-colors group font-medium"
              >
                <span className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
                  <Icon icon="solar:letter-bold" className="w-4 h-4" />
                </span>
                {data.email}
              </a>
            )}
          </div>

          {/* WhatsApp CTA */}
          <button
            onClick={handleWhatsApp}
            className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-50 hover:bg-emerald-100 text-emerald-600 border border-emerald-200 text-xs font-semibold rounded-xl transition-all"
          >
            <Icon icon="ri:whatsapp-fill" className="w-4 h-4" />
            Chat on WhatsApp
          </button>
        </div>
      </div>

      {/* ── Main footer body ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand column */}
          <div className="lg:col-span-1 sm:col-span-2">
            <Link to="/" className="inline-block mb-5">
              <img src={logo} alt="CareSee Logo" className="h-10 object-contain" />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-6 max-w-xs">
              {data?.description || "CareSee is Bangladesh's leading vision therapy platform, combining cutting-edge technology with expert clinical care."}
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-2">
              {socials.map((s) =>
                s.href ? (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.label}
                    className={`w-9 h-9 rounded-xl bg-white border border-gray-200 text-gray-500 flex items-center justify-center transition-all duration-200 ${s.color}`}
                  >
                    <Icon icon={s.icon} className="w-4 h-4" />
                  </a>
                ) : null
              )}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-heading text-sm font-bold text-gray-900 uppercase tracking-widest mb-5">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-gray-500 hover:text-indigo-600 transition-colors flex items-center gap-1.5 group"
                  >
                    <Icon icon="solar:arrow-right-linear" className="w-3 h-3 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all text-indigo-600" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-heading text-sm font-bold text-gray-900 uppercase tracking-widest mb-5">
              Support
            </h3>
            <ul className="space-y-3">
              {supportLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-gray-500 hover:text-indigo-600 transition-colors flex items-center gap-1.5 group"
                  >
                    <Icon icon="solar:arrow-right-linear" className="w-3 h-3 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all text-indigo-600" />
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  onClick={handleWhatsApp}
                  className="text-sm text-gray-500 hover:text-indigo-600 transition-colors flex items-center gap-1.5 group text-left"
                >
                  <Icon icon="solar:arrow-right-linear" className="w-3 h-3 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all text-indigo-600" />
                  Live Support
                </button>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h3 className="font-heading text-sm font-bold text-gray-900 uppercase tracking-widest mb-5">
              Our Locations
            </h3>
            {locations.length > 0 ? (
              <ul className="space-y-3">
                {locations.map((loc, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-500">
                    <Icon icon="solar:map-point-bold" className="w-4 h-4 text-indigo-600 mt-0.5 flex-shrink-0" />
                    {loc}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-400 italic">Location info coming soon.</p>
            )}
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="border-t border-gray-200/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>
            © {new Date().getFullYear()}{" "}
            <span className="text-gray-800 font-semibold">CareSee</span> by Medmyne International. All rights reserved.
          </p>
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            <span>All systems operational</span>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
